// extracted by mini-css-extract-plugin
export default {"blank":"HeadLine_blank__dsmxn","headLine":"HeadLine_headLine__BsPZ3","text5":"HeadLine_text5__OkJA0","highlight":"HeadLine_highlight__QyKBq"};